import Calendar from 'components/ui/Forms/Calendar'
import TextInput from 'components/ui/Forms/TextInput'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from 'components/ui/Popover/Popover'
import { format } from 'date-fns'
import EventIcon from '@mui/icons-material/Event'

const DatesInputsCalendar = ({ label, name, date, handleChange, disabled, ...props }) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <div className="input-calendar-container" style={{ pointerEvents: disabled ? 'none' : 'auto' }}>
          <TextInput
            label={label}
            name={name}
            value={date ? format(date, 'dd/MM/yyyy') : ''}
            style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
            autoComplete="off"
            readOnly
            disabled={disabled}
            {...props}
          />
          <EventIcon
            className="event-icon-calendar"
            style={{
              opacity: disabled ? 0.5 : 1,
              pointerEvents: disabled ? 'none' : 'auto',
              cursor: disabled ? 'not-allowed' : 'pointer',
            }}
          />
        </div>
      </PopoverTrigger>
      <PopoverContent className="custom-body-100" align="start">
        <Calendar selected={date} onDayClick={handleChange} />
      </PopoverContent>
    </Popover>
  )
}

export default DatesInputsCalendar
